import {useEffect, useState} from "react";
import ROITabularRow from "./ROITabularRow";
import info from "../assets/info-icon.png";


const ROITabular = (props) => {

    const [data, setData] = useState([])
    const [showTitleHover, setShowTitleHover] = useState(false)
    const teams = Array.isArray(props.teams) ? props.teams : [];

    useEffect(() => {
        setData(props.data)
    }, [props.data]);

    const normal_round = (value) => {
        if (!value) return;
        if (value - Math.floor(value) < 0.5) return Math.floor(value);
        return Math.ceil(value)
    }

    const formatScore = (score) => {
        let s = normal_round(score)
        if (s > 0) {
            return `+${s}%`
        } else {
            return `${s}%`
        }
    }


    return (
        <div className="roi-tabular-container">
            <div className="summary-tabular-header-container">
                <div className="summary-tabular-title-container" style={{width: "unset"}}>
                    <div className="summary-tabular-title">
                        Numerical View: Team Performance Change (%) by Pillar
                        <img src={info} alt="Info"
                             onMouseOver={() => setShowTitleHover(true)}
                             onMouseLeave={() => setShowTitleHover(false)}
                        />
                        {showTitleHover ?
                            <div className="dashboard-roi-title-hover" style={{top: 42, left: 528}}>
                                <div className="dashboard-roi-title-hover-triangle-outer">
                                    <div className="dashboard-roi-title-hover-triangle-inner"/>
                                </div>
                                <div className="dashboard-roi-title-hover-text regular">
                                    This table shows the percentage change over time of your PERILL scores by Pillar
                                    for each selected team.
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
            {teams.length > 0 ? (
                <>
            <div className="roi-tabular-top-row">
                <div className="roi-tabular-spacer-row"/>
                <div className="summary-tabular-section-column">Purpose & Motivation</div>
                <div className="summary-tabular-section-column">External Systems & Processes</div>
                <div className="summary-tabular-section-column">Relationships</div>
                <div className="summary-tabular-section-column">Internal Systems & Processes</div>
                <div className="summary-tabular-section-column">Learning</div>
                <div className="summary-tabular-section-column">Leadership</div>
            </div>
            <div className="summary-tabular-colour-row">
            <div className="roi-tabular-spacer-row"/>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour blue"/>
                </div>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour red"/>
                </div>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour green"/>
                </div>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour purple"/>
                </div>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour pink"/>
                </div>
                <div className="summary-tabular-section-column">
                    <div className="summary-tabular-pillar-colour orange"/>
                </div>
            </div>
            {data.organisations && data.organisations.map((organisation, idx) => {
                return <ROITabularRow data={organisation} key={idx} generatingReport={props.generatingReport}/>
            })}
            <div className="summary-tabular-spacer-border"/>
            <div className="summary-tabular-team-row mean">
                <div className="roi-tabular-row-name">Overall Mean</div>
                <div className={`summary-tabular-section-column ${data.purpose_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.purpose_change_average)}
                </div>
                <div className={`summary-tabular-section-column ${data.external_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.external_change_average)}
                </div>
                <div className={`summary-tabular-section-column ${data.relationship_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.relationship_change_average)}
                </div>
                <div className={`summary-tabular-section-column ${data.internal_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.internal_change_average)}
                </div>
                <div className={`summary-tabular-section-column ${data.learning_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.learning_change_average)}
                </div>
                <div className={`summary-tabular-section-column ${data.leadership_change_average > 0 ? "green" : "red"}`}>
                    {formatScore(data.leadership_change_average)}
                </div>
            </div>
                </>
            ) : (
                <div className="roi-report-title-card-no-teams">No teams selected</div>
            )}
        </div>
    )
}


export default ROITabular